import "./css/main.css";
//import "@fortawesome/fontawesome-free/css/all.min.css";
//import "./css/font_awesome/fontAwesomeKit.css";
import "@awesome.me/kit-dc13373c4e/icons/css/all.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterHandler } from "@src/Router";
import { BrowserRouter } from "react-router-dom";
import { TimelineDataProvider } from "@src/utility_functions/context/TimelineDataContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { includeGoogleAnalytics } from "@src/utility_functions/analytics/includeGoogleAnalytics";

includeGoogleAnalytics();
const queryClient = new QueryClient();
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <TimelineDataProvider>
          <RouterHandler />
        </TimelineDataProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
